<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'首页'"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="6000" :show-indicators="false" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @dragstart.prevent />
							<div v-if="index == 0" class="msg_box">
								<img src="../../assets/img_public/logo_b.webp" />
								<div class="tit">从有机到安息 全供应链服务 <span>@21亿人</span></div>
								<div class="tips" @click="goMore">
									了解库尔&nbsp;<van-icon name="arrow" size="16px" color="#000000" style="position: relative;top: 3px;" />
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="indicators_box">
					<div v-for="(value, index) in bannerList" :key="index" class="indicators_el" :class="bannerIndex == index ? 'actived' : ''"></div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="tit_box">
					<div class="tit_box_main">
						<div class="left"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>应用场景</div>
						<div v-if="sceneList.length > 0" class="right"
							data-aos="fade-left"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div v-for="(value, index) in sceneList"
								:key="index"
								class="right_el"
								:class="nowsceneAcitved == value.id ? 'actived' : ''"
								@click="checkScene(value)"
							>{{ value.title }}</div>
						</div>
					</div>
				</div>
				<div v-if="cateList.length > 0" class="list_box">
					<div class="list_box_main"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div
							v-for="(value, index) in cateList"
							:key="index"
							class="list_el"
							@mouseover="nowCateAcitved = index"
							@mouseleave="nowCateAcitved = null"
							@click="goProduct(value)"
						>
							<img v-if="value.thumb && value.thumb_active" :src="nowCateAcitved == index ? webUrl + value.thumb_active : webUrl + value.thumb" />
							<div class="tit">{{ value.title }}</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="top_box">
					<div class="tit_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">库尔科技</div>
						<div class="right" @click="goMore">
							<div class="public_btn">了解更多<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
					<div class="txt_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						北京库尔科技有限公司为美国CorDx Union集团旗下子公司。CorDx Union(简称CU)成立于2006年，是综合研发、生产、营销、服务为一体的国际化集团公司，设有Accu News准信、Coretests库尔科技、Abiores佳宝瑞源、Jtests建英佳、Bonore保诺塑业、Cupet夕友生物等品牌系，共21家子公司。CU以医疗器械&诊断试剂为主业，产品销往170多个国家和地区，在全球拥有上亿用户。
					</div>
				</div>
				<div class="bot_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="bg" src="../../assets/img_public/index/block_bg2.webp" />
					<div class="bot_main">
						<div class="title">产品销往170多个国家和地区，在全球拥有上亿用户</div>
						<div class="info_box">
							<div class="left">
								<div class="info_el">
									<img src="../../assets/img_public/index/icon1.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="170" :duration="6000" class="num"></count-to>
											<div class="add" style="right: 0;">+</div>
										</div>
										<div class="tit">市场覆盖国家及地区</div>
									</div>
								</div>
								<div class="info_el">
									<img src="../../assets/img_public/index/icon2.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="1" :duration="6000" class="num"></count-to>
											<div class="add" style="left: 40px;">+</div>
											<div class="count" style="left: 40px;">亿</div>
										</div>
										<div class="tit">用户</div>
									</div>
								</div>
							</div>
							<div class="right">
								<div class="info_el">
									<img src="../../assets/img_public/index/icon3.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="50" :duration="6000" class="num"></count-to>
											<div class="add" style="right: 30px;">+</div>
										</div>
										<div class="tit">资质认证</div>
									</div>
								</div>
								<div class="info_el">
									<img src="../../assets/img_public/index/icon4.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="3" :duration="6000" class="num"></count-to>
											<div class="add" style="left: 40px;font-size: 16px;">㎡</div>
											<div class="count" style="left: 40px;">万</div>
										</div>
										<div class="tit">产业基地面积</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="top_box">
					<div class="tit">全球化业务</div>
					<div class="txt">公司以创一流医药企业为目标，致力于全球化发展，现已在美国、迪拜、新加坡成立了研发中<br />心、生产基地和销售平台，全心全意为人类健康事业服务！</div>
				</div>
				<div class="bot_box">
					<div class="shadow"></div>
					<div id="mapBox" class="map_box">
						<img :src="imgUrl" />
					</div>
					<div class="list_box">
						<div class="top_list">
							<div :class="addressActived == 1 ? 'actived' : ''" @click="addressClick(1)">海外公司</div>
							<div :class="addressActived == 2 ? 'actived' : ''" @click="addressClick(2)">国内公司</div>
						</div>
						<div class="bot_list">
							<template v-if="addressActived == 1">
								<div v-for="(value, index) in addressOut" :key="index" :class="addressActived2 == value.title ? 'actived' : ''" @click="addressClick2(value)">{{ value.title }}</div>
							</template>
							<template v-if="addressActived == 2">
								<div v-for="(value, index) in addressIn" :key="index" :class="addressActived2 == value.title ? 'actived' : ''" @click="addressClick2(value)">{{ value.title }}</div>
							</template>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="tit_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">公司动态</div>
						<div class="right" @click="goNews">
							<div class="public_btn">全部动态<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
					<div class="list_box">
						<div v-if="newsOneList" class="left"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goNewsInfo(newsOneList)"
						>
							<img :src="webUrl + newsOneList.image" />
							<div class="title_box">
								<div class="tit">{{ newsOneList.title }}</div>
								<div class="time">{{ newsOneList.fabu_time }}</div>
							</div>
						</div>
						<div v-if="newsOtherList.length > 0" class="right"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div v-for="(value, index) in newsOtherList" :key="index" class="list_el" @click="goNewsInfo(value)">
								<div class="tit">{{ value.title }}</div>
								<div class="txt">{{ value.description }}</div>
								<div class="time">{{ value.fabu_time }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img_public/index/zw2.webp" />
						<div class="tit">企业文化</div>
						<div class="txt">完美品质&ensp;真诚服务&ensp;规范管理&ensp;开拓创新</div>
						<div class="btn_box">
							<div class="public_btn" @click="goCulture">查看<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img_public/index/zw3.webp" />
						<div class="tit">库尔人</div>
						<div class="txt">共同成长&ensp;共创库尔美好未来</div>
						<div class="btn_box">
							<div class="public_btn" @click="goMore">查看<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import CountTo from 'vue-count-to'
// import AMapLoader from '@amap/amap-jsapi-loader';
import { UPURL } from '@/util/util';
import { newsList } from '@/api/public';  //新闻列表
export default {
	components:{
		navBox,
		footerBox,
		CountTo
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [  //轮播
				{ imgUrl: require('@/assets/img_public/index/banner01.webp') },
				{ imgUrl: require('@/assets/img_public/index/banner02.png') }
			],
			bannerIndex: 0,  //当前轮播索引
			addressActived: 1,
			addressActived2: '美国加州SD',
			imgUrl: require('@/assets/img_public/map/库尔_圣迭戈.webp'),
			addressIn: [
				{ title: '北京', lat: 40.287037, lng: 116.227463, imgUrl: require('@/assets/img_public/map/map_cn/中文版_库尔_北京.webp') },
				{ title: '天津', lat: 39.588283, lng: 117.063738, imgUrl: require('@/assets/img_public/map/map_cn/中文版_库尔_天津.webp') },
				{ title: '河北', lat: 39.24455, lng: 115.515995, imgUrl: require('@/assets/img_public/map/map_cn/中文版_库尔_河北.webp') },
				{ title: '四川', lat: 30.872961, lng: 103.866301, imgUrl: require('@/assets/img_public/map/map_cn/中文版_库尔_四川.webp') },
				{ title: '湖北', lat: 30.527296, lng: 113.924629, imgUrl: require('@/assets/img_public/map/map_cn/中文版_库尔_湖北.webp') },
				// { title: '海南', lat: 20.254845, lng: 109.76684 }
			],
			addressOut: [
				{ title: '美国加州SD', lat: 33.21698, lng: -117.160338, imgUrl: require('@/assets/img_public/map/库尔_圣迭戈.webp') },
				{ title: '亚特兰大', lat: 33.693296, lng: -84.344735, imgUrl: require('@/assets/img_public/map/库尔_亚特兰大.webp') },
				{ title: '新加坡', lat: 1.341561, lng: 103.888903, imgUrl: require('@/assets/img_public/map/库尔_新加坡.webp') },
				{ title: '迪拜', lat: 25.237182, lng: 55.356834, imgUrl: require('@/assets/img_public/map/库尔_迪拜.webp') }
			],
			mapList: null,
			loaction: null,
			sceneList: [],  //应用场景
			cateList: [],  //子分类
			nowsceneAcitved: null,  //当前产品分类选中id
			nowCateAcitved: null,  //当前子应用场景滑动索引
			lang: 'en',
			lang2: sessionStorage.getItem('lang'),
			webUrl: UPURL,
			newsOneList: null,
			newsOtherList: [],
		}
	},
	created(){
		let that = this;
		//产品分类赋值
		if(sessionStorage.getItem('navList')) {
			that.sceneList = JSON.parse(sessionStorage.getItem('navList'))[1].children.scenarios_list;
			that.nowsceneAcitved = that.sceneList[0].id;
			that.cateList = that.sceneList[0].children;
		}
		//请求文章数据
		newsList({
			page: 1,
			page_size: 4,
			leixing: 1,
			language: sessionStorage.getItem('lang')
		}).then(res => {
			res.data.data.forEach((value, index) => {
				if(index == 0) {
					that.newsOneList = value;
				}else {
					that.newsOtherList.push(value);
				}
			});
		});
	},
	mounted() {
		let that = this;
		//初始化地图
		that.mapList = [{ lnglats: [-117.160338, 33.21698], }];
		that.loaction = [-117.160338, 32.71698];
		that.$nextTick(() => {
			// that.initMap();
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//跳转文章详情
		goNewsInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
			window.open(routeData.href, '_blank');
		},
		//跳转新闻
		goNews() {
			this.$router.push('/news/dynamics.html');
		},
		//跳转企业文化
		goCulture() {
			this.$router.push('/about/culture.html');
		},
		//跳转公司简介
		goMore() {
			this.$router.push('/about/introduction.html');
		},
		//点击跳转产品
		goProduct(value) {
			let that = this;
			that.$router.push({ path: '/product-list.html', query: { scenarios_ids: value.id, } });
		},
		//切换产品分类
		checkScene(value) {
			let that = this;
			that.cateList = [];
			that.nowsceneAcitved = value.id;
			that.$nextTick(() => {
				that.cateList = value.children;
			});
		},
		//地点点击2
		addressClick2(value) {
			let that = this;
			if(that.addressActived2 != value.title) {
				that.addressActived2 = value.title;
				//重置地图
				that.mapList = [{ lnglats: [value.lng, value.lat], }];
				that.loaction = [value.lng, value.lat];
				// that.initMap();
				that.imgUrl = value.imgUrl;
			}
		},
		//地点点击1
		addressClick(value) {
			let that = this;
			that.addressActived = value;
			if(that.addressActived == 1) {
				that.lang = 'en';
				that.addressActived2 = '美国加州SD';
				//重置地图
				// that.mapList = [{ lnglats: [-117.160338, 33.21698], }];
				// that.loaction = [-117.160338, 33.21698];
				// that.initMap();
				that.imgUrl = require('@/assets/img_public/map/库尔_圣迭戈.webp');
			}else {
				that.lang = 'cn';
				that.addressActived2 = '北京';
				//重置地图
				// that.mapList = [{ lnglats: [116.227463, 40.287037], }];
				// that.loaction = [116.227463, 40.287037];
				// that.initMap();
				that.imgUrl = require('@/assets/img_public/map/map_cn/中文版_库尔_北京.webp');
			}
		},
		//banner变化
		bannerChange(index) {
			let that = this;
			that.bannerIndex = index;
		},
		//初始化地图
		// initMap() {
		// 	let that = this;
		// 	AMapLoader.load({
		// 		key:"1a79407995c8bc2abb2230330562814e",  // 申请好的Web端开发者Key，首次调用 load 时必填  c7422fb1c71586f2ab0e00eeeda9ea3e
		// 		version:"1.4.15",  // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
		// 		plugins:[''],  // 需要使用的的插件列表，如比例尺'AMap.Scale'等
		// 	}).then((AMap)=>{
		// 		that.map = new AMap.Map("mapBox",{  //设置地图容器id
		// 			viewMode:"3D",    //是否为3D地图模式
		// 			zoom: 0,           //初始化地图级别
		// 			//mapStyle: 'amap://styles/whitesmoke',
		// 			center: that.loaction, //初始化地图中心点位置640419
		// 			lang: ''
		// 		});
		// 		that.setMapMarker();
		// 		that.map.setZoom(6);
		// 		that.map.setLang(that.lang);
		// 	}).catch(e=>{
		// 		console.log(e);
		// 	});
		// },
		// setMapMarker () {
		// 	let that = this;
		// 	// 创建 AMap.Icon 实例
		// 	let icon = new AMap.Icon({
		// 		size: new AMap.Size(36, 36), // 图标尺寸
		// 		image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // Icon的图像
		// 		imageSize: new AMap.Size(24, 30), // 根据所设置的大小拉伸或压缩图片
		// 		imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
		// 	});
		// 	let makerList = []
		// 	that.mapList.forEach((item) => {
		// 		// 遍历生成多个标记点
		// 		let marker = new AMap.Marker({
		// 			map: that.map,
		// 			zIndex: 9999999,
		// 			icon: icon, // 添加 Icon 实例
		// 			offset: new AMap.Pixel(0, 0), //icon中心点的偏移量
		// 			position: item.lnglats // 经纬度对象new AMap.LngLat(x, y)，也可以是经纬度构成的一维数组[116.39, 39.9]
		// 		});
		// 		makerList.push(marker)
		// 	});
		// 	that.map.add(makerList)
		//     that.map.setFitView();
		// },
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块5
	.block_5{
		.block_5_main{
			width: 1264px;
			display: flex;
			margin: 0 auto;
			padding: 100px 0;
			.left, .right{
				flex: 1;
				padding-right: 40px;
				.txt{
					padding: 10px 0 30px 0;
					font-size: 18px;
				}
				.tit{
					padding-top: 30px;
					font-size: 28px;
				}
				img{
					width: 100%;
				}
			}
			.right{
				padding-left: 40px;
				padding-right: 0;
			}
		}
	}
	//块4
	.block_4{
		padding: 100px 0 80px 0;
		background: url(../../assets/img_public/index/block_bg.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_4_main{
			width: 1264px;
			margin: 0 auto;
			.list_box{
				display: flex;
				align-items: center;
				padding-top: 45px;
				.right{
					flex: 1;
					padding-left: 40px;
					.list_el{
						margin-bottom: 20px;
						padding: 0 0 16px 0;
						border-bottom: 1px solid #E3E1E6;
						cursor: pointer;
						.tit{
							font-size: 22px;
						}
						.txt{
							margin: 10px 0 8px 0;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.time{
							font-size: 16px;
							color: #999999;
						}
					}
				}
				.left{
					flex: 1;
					padding-right: 40px;
					border-radius: 8px;
					overflow: hidden;
					cursor: pointer;
					.title_box{
						padding: 20px 24px 24px 24px;
						background-color: #ffffff;
						.time{
							margin-top: 15px;
							color: #999999;
							font-size: 16px;
						}
						.tit{
							font-size: 20px;
						}
					}
					img{
						width: 100%;
					}
				}
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					width: auto;
				}
				.left{
					flex: 1;
					font-size: 44px;
					font-weight: bold;
				}
			}
		}
	}
	//块3
	.block_3{
		padding-top: 100px;
		.bot_box{
			position: relative;
			.shadow{
				display: none;
				// width: 100%;
				// height: 154px;
				// position: absolute;
				// z-index: 1;
				// top: 0;
				// background: #ffffff;
				// opacity: 0.2;
			}
			.list_box{
				width: 1110px;
				left: 50%;
				transform: translate(-50%, 0);
				bottom: 60px;
				position: absolute;
				z-index: 1;
				.bot_list{
					display: flex;
					margin-top: 30px;
					padding: 38px 0;
					background: #FFFFFF;
					box-shadow: 0px 0px 30px 1px rgba(0,0,0,0.1);
					border-radius: 8px;
					text-align: center;
					div{
						flex: 1;
						font-size: 20px;
						cursor: pointer;
						border-right: 1px solid #E3E1E6;
					}
					div:hover{
						color: #A20073;
					}
					div.actived{
						color: #A20073;
					}
					div:last-child{
						border-right: none;
					}
				}
				.top_list{
					div{
						display: inline-block;
						margin-right: 20px;
						padding: 12px 20px 8px 20px;
						border-radius: 8px;
						cursor: pointer;
						font-size: 20px;
					}
					div.actived{
						color: #A20073;
						background-color: #ffffff;
					}
				}
			}
			.map_box{
				width: 100%;
				// height: 600px;
				img{
					width: 100%;
				}
			}
		}
		.top_box{
			width: 1264px;
			margin: 0 auto;
			text-align: center;
			.txt{
				padding: 20px 0 40px 0;
				font-size: 20px;
			}
			.tit{
				font-size: 44px;
				font-weight: bold;
			}
		}
	}
	//块2
	.block_2{
		padding-top: 100px;
		.bot_box{
			position: relative;
			.bot_main{
				width: 1264px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				.info_box{
					display: flex;
					padding: 20px 0 0px 0;
					.left, .right{
						flex: 1;
						.info_el{
							padding-top: 60px;
							.info_info{
								width: 360px;
								margin-left: 40px;
								padding: 0 0 25px 0px;
								display: inline-block;
								border-bottom: 1px solid #E3E1E6;
								.info_info_box{
									width: 120px;
									display: inline-block;
									position: relative;
									.count{
										position: absolute;
										bottom: 16px;
										font-size: 14px;
										line-height: 1;
										color: #A20073;
									}
									.add{
										position: absolute;
										top: 0;
										font-size: 24px;
										line-height: 1;
										color: #A20073;
									}
									.num{
										font-size: 62px;
										color: #A20073;
										line-height: 1;
									}
								}
								.tit{
									margin-left: 20px;
									display: inline-block;
									position: relative;
									top: -16px;
								}
							}
							img{
								width: 48px;
								height: 48px;
							}
						}
					}
				}
				.title{
					font-size: 30px;
				}
			}
			img.bg{
				min-width: 1264px;
				width: 100%;
			}
		}
		.top_box{
			width: 1264px;
			margin: 0 auto;
			.txt_box{
				padding: 20px 0 50px 0;
				font-size: 20px;
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					width: auto;
				}
				.left{
					flex: 1;
					font-size: 44px;
					font-weight: bold;
				}
			}
		}
	}
	//块1
	.block_1{
		.list_box{
			background: url(../../assets/img_public/index/block_bg.webp) no-repeat 100% 100%;
			background-size: cover;
			.list_box_main{
				width: 1264px;
				margin: 0 auto;
				padding: 150px 0 100px 0;
				text-align: center;
				.list_el{
					display: inline-block;
					margin: 0 35px 50px 35px;
					cursor: pointer;
					.tit{
						padding-top: 15px;
						font-size: 20px;
						text-align: center;
					}
					img{
						width: 140px;
						height: 140px;
					}
				}
			}
		}
		.tit_box{
			padding: 45px 0 40px 0;
			border-bottom: 1px solid rgba(51, 51, 51, 0.2);
			.tit_box_main{
				width: 1264px;
				display: flex;
				align-items: center;
				margin: 0 auto;
				.right{
					flex: 1;
					text-align: right;
					.right_el{
						display: inline-block;
						margin-left: 20px;
						padding: 10px 18px;
						font-size: 20px;
						cursor: pointer;
					}
					.right_el.actived{
						color: #A20073;
						border: 1px solid #ECE7E8;
						border-radius: 8px;
					}
				}
				.left{
					width: auto;
					font-size: 44px;
					font-weight: bold;
				}
			}
		}
	}
	//轮播图
	.banner_box{
		min-width: 1300px;
		position: relative;
		.indicators_box{
			position: absolute;
			bottom: 50px;
			left: 50%;
			transform: translate(-50%, 0);
			.indicators_el{
				width: 100px;
				height: 2px;
				display: inline-block;
				margin: 0 5px;
				background-color: rgba(0, 0, 0, 0.3);
			}
			.actived{
				background-color: #A20073;
			}
		}
		.swipe_box{
			.swiper_el{
				position: relative;
				.msg_box{
					width: 1264px;
					margin: 0 auto;
					position: absolute;
					top: 40%;
					left: 50%;
					transform: translate(-50%, -40%);
					.tips{
						margin-top: 80px;
						display: inline-block;
						font-size: 16px;
						padding: 8px 16px;
						border-radius: 8px;
						border: 1px solid #999999;
					}
					.tit{
						margin-top: 20px;
						font-size: 24px;
						span{
							font-size: 24px;
							font-weight: bold;
							color: #A20073;
						}
					}
					img{
						width: 470px;
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>